export const BROWSER_STORAGE_KEYS = {
  auth: "suraasaKindAuth",
  tempDeviceId: "tempDeviceId",
}
export const PLATFORM = "Suraasa Kind"

export type Captcha = {
  value: string
  type: CaptchaType
}

export enum CaptchaType {
  checkbox = "checkbox",
  invisible = "invisible",
}

export const IS_DEV_ENVIRONMENT =
  import.meta.env.VITE_DEPLOYMENT_ENVIRONMENT === "dev"
export const IS_PROD_ENVIRONMENT =
  import.meta.env.VITE_DEPLOYMENT_ENVIRONMENT === "prod"

export const MAX_FILE_SIZE_MB = 5
export const VALID_IMAGE_TYPES = [
  ".jpeg",
  ".jpg",
  ".png",
  ".webp",
  ".avif",
  ".svg",
  ".heic",
  ".heif",
]

export const IS_LOCALHOST = import.meta.env.DEV
